// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-box {\n  padding: 10px 20px;\n}\n.button-box .el-button {\n  margin-right: 20px;\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
